// extracted by mini-css-extract-plugin
export var description = "MilestoneItem-module--description--ad4f7";
export var icon = "MilestoneItem-module--icon--f3e0a";
export var item = "MilestoneItem-module--item--87162";
export var normalIcon = "MilestoneItem-module--normal-icon--8f093";
export var title = "MilestoneItem-module--title--80d06";